import * as go from 'gojs';
import { getDiagram } from 'gojs/goDiagram';
import theme from 'theme/theme';

/**
 * Generates a thumbnail from the current diagram
 * @returns Base64 encoded JPEG image data, or null if diagram is not available
 */
export const generateThumbnailFromDiagram = (): string | null => {
  const diagram = getDiagram();
  if (!diagram) {
    return null;
  }

  const imageData = diagram.makeImageData({
    size: new go.Size(500, NaN),
    background: theme.palette.grey[50],
    showGrid: true,
    type: 'image/jpeg',
    // @ts-expect-error - GoJS type definitions missing details property
    details: 0.2,
  }) as string;

  return imageData || null;
};
